<div class="wrapper">
  <!--new care design-->
  <h5 class="main-title">{{patientPersonalInfo.PracticeName || 'N/A'}}</h5>
  <div *ngIf="isEditInfoSection" class="main-info">{{'careteam.your_careTeam'|translate}}</div>
  <div  *ngIf="isMaincareTeamsection" class="main-info">  {{'careteam.add_Your_care_team_member'|translate}}</div>
  <div class="main-wrapper">


    <!--Main care team section-->
    <ng-container *ngIf="isMaincareTeamsection">
      <div class="container flex-grow-1 ">
        <div class="row">
          <div class="col-md-12">
            <!--<div class="form-label padding-left" style="margin-bottom:10px">
              {{'careteam.add_Your_care_team_member'|translate}}
            </div>-->
            <div class="form-group mb-4">
              <div class="row">
                <div class="col-md-4 mb-2">
                  <div class="custom-control custom-radio mb-1">
                    <input class="custom-control-input" type="radio" id="pcp" name="careTeam" value="PCP" (change)="onSelect($event)" checked>
                    <label class="custom-control-label" for="pcp">{{'careteam.relation_to_patient_primary_care_provider'|translate}}</label>
                  </div>
                </div>
                <div class="col-md-4 mb-2">
                  <div class="custom-control custom-radio mb-1">
                    <input class="custom-control-input" type="radio" id="referringProvider" name="careTeam" value="Referring Provider" (change)="onSelect($event)">
                    <label class="custom-control-label" for="referringProvider">{{'careteam.relation_to_patient_referring_provider'|translate}}</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="custom-control custom-radio mb-1">
                    <input class="custom-control-input" type="radio" id="other" name="careTeam" value="O" (change)="onSelect($event)">
                    <label class="custom-control-label" for="other">{{'careteam.relation_to_patient_other'|translate}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="col-md-12">

            <!--Referring Doctor-->

            <div *ngIf="selectedOption === 'Referring Provider'">
              <div class="form-label padding-left">
                {{'careteam.search_referring_doctor_from_any_clinic'|translate}}
              </div>
              <div class="dropdown input-icon search form-floating mt-2" ngbDropdown style="flex: 2;" #careteamDrop="ngbDropdown">
                <input placeholder="{{'careteam.search_provider_by_name_or_NPI'|translate}}" autocomplete="off" ngbDropdownAnchor (focus)="careteamDrop.open()"
                       class="form-control text-left" type="text" id="careteaminfodropdown"
                       aria-haspopup="true" aria-expanded="false"
                       (onblur)="onBlur()" [(ngModel)]="searchStr" (input)="searchCareTeam($event)">
                <label>{{'careteam.provider'|translate}}</label>
                <div ngbDropdownMenu class="custom-menu" [ngClass]="{'d-none': dNone}" aria-labelledby="careteaminfodropdown">
                  <button ngbDropdownItem *ngIf="searchingSpecialist">
                    <span>{{'careteam.loading'|translate}}</span>
                  </button>
                  <button ngbDropdownItem *ngIf="noRecs && !searchingSpecialist && results.length == 0">{{'careteam.no_records_found'|translate}}</button>
                  <div class="text-center">
                    <button class="btn btn-primary selectcare" *ngIf="noRecs && !searchingSpecialist && results.length == 0" (click)="addcareTeamManually('rp')">{{'careteam.add_your_own_referringProvider'|translate}}</button>
                  </div>
                  <button ngbDropdownItem *ngFor="let c of results" (click)="SetCareTeam(c)">
                    <span class="d-block ">
                      <h6 class="mb-1 font-weight-bold">{{c.basic?.first_name | titlecase}} {{c.basic?.last_name | titlecase}}</h6>
                      <span>{{c.taxonomies[0]?.desc}}</span> <br>
                      <span>{{c.addresses[0]?.address_1 | titlecase}}</span><br>
                      <span>{{c.addresses[0]?.city | titlecase}}, {{c.addresses[0]?.state}} {{c.addresses[0].postal_code.substring(0, 5)}}</span>
                    </span>
                  </button>
                </div>
              </div>

            </div>

            <!--PCP-->

            <div *ngIf="selectedOption === 'PCP'">
              <div class="form-label padding-left">
                {{'careteam.search_primarycare_from_any_clinic'|translate}}
              </div>
              <div class="dropdown input-icon search form-floating mt-2" ngbDropdown style="flex: 2;" #careteamDrop="ngbDropdown">
                <input placeholder="{{'careteam.search_provider_by_name_or_NPI'|translate}}" autocomplete="off" ngbDropdownAnchor (focus)="careteamDrop.open()"
                       class="form-control text-left" type="text" id="careteaminfodropdown"
                       aria-haspopup="true" aria-expanded="false"
                       (onblur)="onBlur()" [(ngModel)]="searchStr" (input)="searchCareTeam($event)">
                <label>{{'careteam.provider'|translate}}</label>
                <div ngbDropdownMenu class="custom-menu" [ngClass]="{'d-none': dNone}" aria-labelledby="careteaminfodropdown">
                  <button ngbDropdownItem *ngIf="searchingSpecialist">
                    <span>{{'careteam.loading'|translate}}</span>
                  </button>
                  <button ngbDropdownItem *ngIf="noRecs && !searchingSpecialist && results.length == 0">{{'careteam.no_records_found'|translate}}</button>
                  <div class="text-center">
                    <button class="btn btn-primary selectcare" *ngIf="noRecs && !searchingSpecialist && results.length == 0" (click)="addcareTeamManually('pcp')">{{'careteam.add_your_own_pcp'|translate}}</button>
                  </div>
                  <button ngbDropdownItem *ngFor="let c of results" (click)="SetCareTeam(c)">
                    <span class="d-block ">
                      <h6 class="mb-1 font-weight-bold">{{c.basic?.first_name | titlecase}} {{c.basic?.last_name | titlecase}}</h6>
                      <span>{{c.taxonomies[0]?.desc}}</span> <br>
                      <span>{{c.addresses[0]?.address_1 | titlecase}}</span><br>
                      <span>{{c.addresses[0]?.city | titlecase}}, {{c.addresses[0]?.state}} {{c.addresses[0].postal_code.substring(0, 5)}}</span>
                    </span>
                  </button>
                </div>
              </div>

            </div>
            <!--other-->
            <div *ngIf="selectedOption === 'O'" class="form-group mb-4">
              <form [formGroup]="addCareTeamForm">
                <div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group form-floating">
                        <input formControlName="FIRST_NAME" type="text" maxlength="35" placeholder="{{'careteam.first_name'|translate}}" class="form-control" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
                        <label>{{'careteam.first_name'|translate}} <span class="text-danger">*</span></label>
                        <span class="err" *ngIf="getCareTeamForm.FIRST_NAME.invalid && getCareTeamForm.FIRST_NAME.touched">{{'careteam.first_name_error_message'|translate}}</span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group form-floating">
                        <input formControlName="LAST_NAME" type="text" maxlength="35" placeholder="{{'careteam.last_name'|translate}}" class="form-control" (input)="onlyCharAllow($event.target,'LAST_NAME')">
                        <label>{{'careteam.last_name'|translate}} <span class="text-danger">*</span></label>
                        <span *ngIf="getCareTeamForm.LAST_NAME.invalid" class="text-left d-block text-danger">
                          <span class="err" *ngIf="getCareTeamForm.LAST_NAME.touched && getCareTeamForm.LAST_NAME.invalid">{{'careteam.last_name_error_message'|translate}}</span>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group form-floating">
                        <input formControlName="ADDRESS" (keypress)="limitCharsOnly($event, 35)" maxlength="35" type="text" placeholder="{{'careteam.address'|translate}}" class="form-control">
                        <label>{{'careteam.address'|translate}} <span class="text-danger">*</span></label>
                        <span class="err" *ngIf="getCareTeamForm.ADDRESS.invalid && getCareTeamForm.ADDRESS.touched">{{'careteam.address_error_message'|translate}}</span>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group form-floating">
                        <input formControlName="ZIP" maxlength="10" minlength="5" (input)="onlyNumberAllow($event);" type="text" placeholder="{{'careteam.zipcode'|translate}}" class="form-control">
                        <label>{{'careteam.zipcode'|translate}} <span class="text-danger">*</span></label>
                        <div class="err" *ngIf="getCareTeamForm.ZIP.invalid && getCareTeamForm.ZIP.touched">
                          <span class="err" *ngIf="getCareTeamForm.ZIP.errors!.required">{{'careteam.zipcode_error_message'|translate}}</span>
                          <span class="err" *ngIf="getCareTeamForm.ZIP.errors!.zipNotFound">{{'careteam.zipcode_invalid'|translate}}</span>
                          <span class="err" *ngIf="getCareTeamForm.ZIP.errors!.minlength">{{'careteam.zipcode_invalid'|translate}}</span>
                        </div>
                        <div class="err" *ngIf="getCareTeamForm.ZIP.valid && getCareTeamForm.CITY.touched && getCareTeamForm.CITY.invalid">
                          <span class="err" *ngIf="getCareTeamForm.CITY.errors!.required">{{'careteam.zipcode_invalid'|translate}}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group form-select form-floating">
                        <select translate="no" [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control mr-sm-1 mb-2" formControlName="CITY" (change)="showState($event)">
                          <option value selected disabled>{{'careteam.city'|translate}}*</option>
                          <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName}}</option>
                        </select>
                        <label>{{'careteam.city'|translate}} <span class="text-danger">*</span></label>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group form-floating">
                        <input formControlName="STATE" [attr.disabled]="true" type="text" placeholder="{{'careteam.state'|translate}}" class="form-control">
                        <label>{{'careteam.state'|translate}} <span class="text-danger">*</span></label>
                      </div>
                    </div>

                    <div *ngIf="careTeamMemberOption==='O'" class="col-md-4">
                      <div class="form-group form-floating">
                        <input (keypress)="validateRelation($event)" formControlName="RELATION" type="text" placeholder="{{'careteam.relationship_enter_Relationship'|translate}}" class="form-control" maxlength="100">
                        <label>{{'careteam.relationship'|translate}} <span class="text-danger">*</span></label>
                        <span class="err" *ngIf="getCareTeamForm.RELATION.value.length == 0 && getCareTeamForm.RELATION.touched">{{'careteam.relationship_error_message'|translate}}</span>
                      </div>

                    </div>

                  </div>
                  <div class="text-left">
                    <button *ngIf="selectedOption === 'O'" class="btn btn-primary btncare mb-4" type="button" (click)="selectedOption==='O'?AddCareTeam():(careteams.length>0? backtoEditcare():nextClick())">{{'button.saveforme'|translate}}​</button>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
    </ng-container>

    <!-- care team info section-->

    <ng-container *ngIf="isEditInfoSection">
      <div class="container flex-grow-1 overflow-auto">
        <div class="specialist-list">
          <div class="text-right">
            <button class="btn btn-primary btncare mb-4" *ngIf="isEditInfoSection" (click)="backToMainCare()">{{'button.add_another'|translate}}</button>
          </div>
          <div class="row">
            <div class="col-lg-6" *ngFor="let cteam of careteams">
              <div class="card border-bottom mb-4 pb-3">
                <div class="card-body p-0">
                  <div class="align-items-center d-flex justify-content-between mb-2">
                    <h6 class="font-weight-bold mb-0">{{cteam.FIRSTNAME | titlecase}} {{cteam.LASTNAME | titlecase}}</h6>
                    <div class="ctabtns">
                      <!--<a href="javascript:void(0)" (click)="SetCareTeamUpdate(cteam)" class="text-muted">Edit</a>
                      <span class="text-muted">|</span>-->
                      <a href="javascript:void(0)" (click)="SetCareTeamDelete(cteam)" class="text-dark">{{'button.delete'|translate}}</a>
                    </div>
                  </div>
                  <div class="d-flex flex-column mb-2">
                    <span class="text-muted">{{cteam.RELATION | titlecase}}</span>
                    <span class="text-muted">{{cteam.ADDRESS | titlecase}}, {{cteam.City | titlecase}}</span>
                    <span class="text-muted"> {{cteam.State}} {{cteam.Zip}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!--Add careTeam-->
    <ng-container *ngIf="isAddCareTeamBySearch">
      <div class="container flex-grow-1 overflow-auto">
        <h5 *ngIf="!updateCareTeamSection" class="text-center mb-4 ">Add care team member from other clinic(s)</h5>
        <h5 *ngIf="updateCareTeamSection" class=" text-center mb-4 ">Update care team member</h5>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left ">NPI<span class="text-danger">*</span></span>
              <input *ngIf="!updateCareTeamSection" type="text" placeholder="NPI" disabled value="{{addcareteam!.NPI}}" class="form-control border-0">
              <input *ngIf="updateCareTeamSection" type="text" placeholder="NPI" disabled [(ngModel)]="updateCareteam!.NPI" class="form-control border-0">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">
                First Name<span class="text-danger">*</span>
              </span>
              <input *ngIf="!updateCareTeamSection" type="text" placeholder="First Name" required maxlength="35" #fname="ngModel" [(ngModel)]="addcareteam.FIRST_NAME" class="form-control border-0" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
              <input *ngIf="updateCareTeamSection" type="text" placeholder="First Name" maxlength="35" #firstname="ngModel" [(ngModel)]="updateCareteam!.FIRST_NAME" class="form-control border-0" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
            </div>
            <span class="err" *ngIf="fname.touched && fname.invalid || firstname.touched && updateCareteam!.FIRST_NAME == ''">First name is required.</span>


          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">Last Name<span class="text-danger">*</span></span>
              <input *ngIf="!updateCareTeamSection" type="text" placeholder="Last Name" required #lname="ngModel" [(ngModel)]="addcareteam.LAST_NAME" class="form-control border-0" (input)="onlyCharAllow($event.target,'LAST_NAME')">
              <input *ngIf="updateCareTeamSection" type="text" placeholder="Last Name" maxlength="35" #lastname="ngModel" [(ngModel)]="updateCareteam!.LAST_NAME" class="form-control border-0" (input)="onlyCharAllow($event.target,'LAST_NAME')">
            </div>
            <span class="err" *ngIf="lname.touched && lname.invalid ||lastname.touched && updateCareteam!.LAST_NAME == ''">Last name is required.</span>


          </div>
          <div class="col-md-8">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">Address<span class="text-danger">*</span></span>
              <input *ngIf="!updateCareTeamSection" type="text" placeholder="Address" #adr="ngModel" required [(ngModel)]="addcareteam.ADDRESS" class="form-control border-0" (input)="validateName($event)">
              <input *ngIf="updateCareTeamSection" type="text" placeholder="Address" #address="ngModel" [(ngModel)]="updateCareteam!.ADDRESS" class="form-control border-0">
            </div>

            <span class="err" *ngIf="address.touched && updateCareteam!.ADDRESS == ''||adr.touched && adr.invalid">Address is required.</span>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">Zip Code<span class="text-danger">*</span></span>

              <input *ngIf="!updateCareTeamSection" maxlength="10" minlength="5" required type="text" [(ngModel)]="addcareteam.ZIP"
                     (input)="onlyNumberAllow($event)" #zi="ngModel" placeholder="ZIP Code"
                     class="form-control border-0">
              <input *ngIf="updateCareTeamSection" maxlength="10" minlength="5" (input)="onlyNumberAllow($event);" type="text"
                     placeholder="Zip Code" #zip="ngModel" [(ngModel)]="updateCareteam!.ZIP"
                     class="form-control border-0">
            </div>

            <span class="err" *ngIf="updateCareTeamSection && zi.touched && updateCareteam!.ZIP.length > 0 && updateCareteam!.CITY == ''">Invalid ZIP Code.</span>
            <span class="err" *ngIf="!updateCareTeamSection && zi.touched && addcareteam.ZIP.length > 0 && addcareteam.CITY == ''">Invalid ZIP Code.</span>


          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">City<span class="text-danger">*</span></span>
              <select *ngIf="!updateCareTeamSection" translate="no" [(ngModel)]="addcareteam!.CITY" [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control border-0"
                      (change)="showState($event)">
                <option *ngIf="addcareteam.CITY != '' && getCityState.length == 0" selected disabled class="text-capitalize">{{addcareteam!.CITY}}</option>
                <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName  | titlecase}}</option>
              </select>
              <select *ngIf="updateCareTeamSection" translate="no" [(ngModel)]="updateCareteam!.CITY"
                      [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control border-0"
                      (change)="showState($event)">
                <option *ngIf="updateCareteam!.CITY && getCityState.length == 0" selected disabled>{{updateCareteam!.CITY}}</option>
                <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName |titlecase}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">State<span class="text-danger">*</span></span>
              <input *ngIf="!updateCareTeamSection" type="text" disabled placeholder="State" value="{{addcareteam!.STATE}}" class="form-control border-0">
              <input *ngIf="updateCareTeamSection" type="text" disabled placeholder="State" [(ngModel)]="updateCareteam!.STATE" class="form-control border-0">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">Email</span>
              <input *ngIf="!updateCareTeamSection" type="email" #emm="ngModel" placeholder="Email" [(ngModel)]="addcareteam.EMAIL" (keypress)="valEmailSearchAdd($event)" class="form-control border-0">
              <input *ngIf="updateCareTeamSection" type="email" name="email" placeholder="Email" (keypress)="valEmail($event)" [(ngModel)]="updateCareteam!.EMAIL" class="form-control border-0">
            </div>
            <span class="err" *ngIf="emm.touched && emError1||emError">Enter valid email.</span>


          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 border-bottom">
              <span class="form-label padding-left fw-bold">Specialty</span>
              <input *ngIf="!updateCareTeamSection" type="text" value="{{addcareteam!.SPECIALITY}}" class="form-control border-0">
              <input *ngIf="updateCareTeamSection" type="text" [(ngModel)]="updateCareteam!.SPECIALITY" class="form-control border-0">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-4 pb-2 border-bottom">
              <span class="form-label padding-left fw-bold">
                Relation to Patient<span class="text-danger">*</span>
              </span>
              <div *ngIf="updateCareTeamSection">
                <div class="custom-control custom-radio mb-1">
                  <input class="custom-control-input" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="inlineRadio11"
                         [checked]="updateCareteam.REFERRINGPROVIDER == true ? true : ''" value="RP">
                  <label class="custom-control-label" for="inlineRadio11">Referring Provider</label>
                </div>
                <div class="custom-control custom-radio mb-1">
                  <input class="custom-control-input" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="inlineRadio22"
                         [checked]="updateCareteam.PCP ? true : ''" value="PCP">
                  <label class="custom-control-label" for="inlineRadio22">Primary Care Provider (PCP)</label>
                </div>
                <div class="custom-control custom-radio mb-1">
                  <input class="custom-control-input" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="other33"
                         [checked]="updateCareteam.OTHER == true ? true : ''" value="OTHER">
                  <label class="custom-control-label" for="other33">Other</label>
                </div>

              </div>
              <div *ngIf="!updateCareTeamSection">
                <span *ngIf="relRequired" class="d-block err"> Please select Relation to Patient.</span>
                <div class="custom-control custom-radio mb-1">
                  <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                         id="b" value="RP">
                  <label class="custom-control-label" for="b">Referring Provider</label>
                </div>
                <div class="custom-control custom-radio mb-1">
                  <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                         id="n" value="PCP">
                  <label class="custom-control-label" for="n">Primary Care Provider (PCP)</label>
                </div>
                <div class="custom-control custom-radio mb-1">
                  <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                         id="t" value="OTHER">
                  <label class="custom-control-label" for="t">Other</label>
                </div>

              </div>
              <div class="mt-3">
                <div class="form-group">
                  <label>Relationship<span class="text-danger">*</span></label>
                  <input *ngIf="updateCareTeamSection" type="text" (keypress)="validateRelation($event)" [attr.disabled]="!updateCareteam.OTHER ? true : null" maxlength="100" [(ngModel)]="updateCareteam!.RELATION" placeholder="Enter Relationship" class="form-control border-0">
                  <input *ngIf="!updateCareTeamSection" type="text" [attr.disabled]="!addcareteam.OTHER ? true : null" (keypress)="validateRelation($event)" maxlength="100" [(ngModel)]="addcareteam!.RELATION" placeholder="Enter Relationship" class="form-control border-0">
                </div>
                <span class="err" *ngIf="!updateCareTeamSection && isOthersEdit && addcareteam!.RELATION.length == 0 ">Please enter Relation.</span>

              </div>
            </div>
          </div>

        </div>
      </div>
    </ng-container>

    <footer class="p-3">
      <div class="container p-0">
        <div class="d-flex justify-content-between align-items-center">
          <button class="btn btn-outline-primary" type="button" (click)="backClick()">{{'button.back'|translate}}</button>
          <p class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>
          <button *ngIf="careteams.length > 0" class="btn btn-primary" type="button" (click)="nextClick()">{{'button.next'|translate}}</button>
          <button *ngIf="careteams.length == 0" class="btn btn-primary" type="button" (click)="nextClick()">{{'button.skip'|translate}}</button>
        </div>
      </div>
    </footer>

    <!--<footer>
      <div class="container p-0">
        <div class="d-flex justify-content-between align-items-center">
          <div class="col-md-12">
            <div class="row justify-content-center mb-3">

                <button *ngIf="isMaincareTeamsection" class="btn btn-outline-primary" type="button" (click)="careteams.length>0? backtoEditcare():backClick()">{{'button.back'|translate}}</button>
                <button *ngIf="isMaincareTeamsection" class="btn btn-primary" type="button" (click)="careteams.length>0? backtoEditcare(): nextClick()">{{'button.skip'|translate}}</button>
                <button *ngIf="isEditInfoSection" class="btn btn-outline-primary" type="button" (click)="careteams.length>0? backClick():''">{{'button.back'|translate}}</button>
                <button *ngIf="isEditInfoSection" class="btn btn-primary" type="button" (click)="careteams.length>0? nextClick():''">{{'button.skip'|translate}}</button>

            </div>
            <div class="row justify-content-center">
              <div class="col-md-6 col-12">

                <button *ngIf="selectedOption === 'O'" class="btn btn-primary px-4 btn-sm w-100" type="button" (click)="selectedOption==='O'?AddCareTeam():(careteams.length>0? backtoEditcare():nextClick())">{{'button.saveforme'|translate}}​</button>
                <button *ngIf="isEditInfoSection" class="btn btn-primary px-4 btn-sm w-100" type="button" (click)="backToMainCare()">{{'button.wantToaddMore'|translate}}</button>
              </div>
            </div>
            <div class="col-md-12" *ngIf="isAddCareTeamBySearch">
              <div class="row justify-content-center mb-3">
                <div class="col-md-6 col-12 d-flex gap-10 ">
                  <a class="btn btn-outline-primary px-4 btn-sm w-50" type="button"
                     (click)="careteams.length>0?backtoEditcare():backToMainCare(); reset()">{{'button.cancel'|translate}}</a>
                  <a class="btn btn-primary px-4 btn-sm w-50" type="button"
                     (click)="updateCareTeamSection? UpateCareTeam():SaveCareTeam();backtoEditcare()">{{'button.save'|translate}}</a>
                </div>
              </div>-->
    <!--<div class="row justify-content-center">
      <div class="col-md-6 col-12">
        <a class="btn btn-primary px-4 btn-sm w-100" type="button"
          (click)="updateCareTeamSection? UpateCareTeam():SaveCareTeam();backToMainCare()" >Save and add more​</a>
      </div>
    </div>-->
    <!--</div>

          </div>
        </div>
      </div>
    </footer>-->

  </div>

  <!--new care design end-->
  <!--<div class="container px-0">
    <h5 class="main-title">{{patientPersonalInfo.PracticeName || 'N/A'}}</h5>
    <div class="main-info pb-3">Care Team Information</div>
    <div class="dropdown input-icon search form-floating" ngbDropdown style="flex: 2;" #careteamDrop="ngbDropdown">
      <input placeholder="Search provider by Name or NPI" autocomplete="off" ngbDropdownAnchor (focus)="careteamDrop.open()"
             class="form-control text-left" type="text" id="careteaminfodropdown"
             aria-haspopup="true" aria-expanded="false"
             (onblur)="onBlur()" [(ngModel)]="searchStr" (input)="searchCareTeam($event)">
      <label>Provider</label>
      <div ngbDropdownMenu class="custom-menu" [ngClass]="{'d-none': dNone}" aria-labelledby="careteaminfodropdown">
        <button ngbDropdownItem *ngIf="searchingSpecialist">
          <span>Loading..</span>
        </button>
        <button ngbDropdownItem *ngIf="noRecs && !searchingSpecialist && results.length == 0">No records found.</button>
        <button ngbDropdownItem *ngFor="let c of results" (click)="SetCareTeam(c)">
          <span class="d-block ">
            <h6 class="mb-1 font-weight-bold">{{c.basic?.first_name | titlecase}} {{c.basic?.last_name | titlecase}}</h6>
            <span>{{c.taxonomies[0]?.desc}}</span> <br>
            <span>{{c.addresses[0]?.address_1 | titlecase}}</span><br>
            <span>{{c.addresses[0]?.city | titlecase}}, {{c.addresses[0]?.state}} {{c.addresses[0].postal_code.substring(0, 5)}}</span>
          </span>
        </button>
      </div>
    </div>
    <div class="devider mb-4">
      <span>OR</span>
    </div>
    <div class="text-center">-->
  <!-- [disabled]="careteams.length == 10" -->
  <!--<button class="btn btn-primary" data-toggle="modal" (click)="ShowError()">
          Add your own Care Team Member
        </button>
      </div>
    </div>


    <div class="container px-0">
      <div class="specialist-list pt-4">
        <div class="form-row">
          <div class="col-lg-6" *ngFor="let cteam of careteams">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-sm-row justify-content-between mb-2">
                  <h6 class="font-weight-bold mb-0">{{cteam.FIRSTNAME | titlecase}} {{cteam.LASTNAME | titlecase}}</h6>
                  <div class="ctabtns d-flex">
                    <a href="javascript:void(0)" (click)="SetCareTeamUpdate(cteam)" class="mr-3"><i title="Edit" class="fas fa-edit text-muted"></i></a>
                    <a href="javascript:void(0)" (click)="SetCareTeamDelete(cteam)"><i title="Delete" class="far fa-trash-alt text-danger"></i></a>
                  </div>
                </div>
                <div class="mb-2">
                  <span class="text-muted font-weight-bold mr-1">Relation to Patient:</span>
                  <span>{{cteam.RELATION | titlecase}}</span>
                </div>
                <div>
                  <span class="text-muted font-weight-bold mr-1">Contact Details:</span>
                  <span>{{cteam.ADDRESS | titlecase}}</span>
                  <span class="d-block mt-1">{{cteam.City | titlecase}}, {{cteam.State}} {{cteam.Zip}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->
  <!--<footer class="p-3">
    <div class="container p-0">
      <div class="d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-primary" type="button" (click)="backClick()">Back</button>
      <p class="mb-0">({{pageNum}} of {{totalPages}})</p>
      <button *ngIf="careteams.length > 0" class="btn btn-primary" type="button" (click)="nextClick()">Next</button>
      <button *ngIf="careteams.length == 0" class="btn btn-primary" type="button" (click)="nextClick()">Skip</button>
      </div>
    </div>
  </footer>-->
</div>
<!--new design update care modal-->

<div class="modal fade" id="UpdateCareTeamMoodall" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Care Team</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <label>NPI</label>
              <input type="text" placeholder="NPI" disabled [(ngModel)]="updateCareteam!.NPI" class="form-control">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Last Name <span class="text-danger">*</span></label>
              <input type="text" placeholder="Last Name" maxlength="35" #lastname="ngModel" [(ngModel)]="updateCareteam!.LAST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'LAST_NAME')">
              <span class="err" *ngIf="lastname.touched && updateCareteam!.LAST_NAME == ''">Last name is required.</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>First Name <span class="text-danger">*</span></label>
              <input type="text" placeholder="First Name" maxlength="35" #firstname="ngModel" [(ngModel)]="updateCareteam!.FIRST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
              <span class="err" *ngIf="firstname.touched && updateCareteam!.FIRST_NAME == ''">First name is required.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Address <span class="text-danger">*</span></label>
              <input type="text" placeholder="Address" #address="ngModel" [(ngModel)]="updateCareteam!.ADDRESS" class="form-control text-capitalize">
              <label>Address <span class="text-danger">*</span></label>
              <span class="err" *ngIf="address.touched && updateCareteam!.ADDRESS == ''">Address is required.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Zip <span class="text-danger">*</span></label>
              <input maxlength="10" minlength="5" (input)="onlyNumberAllow($event);" type="text"
                     placeholder="Zip Code" #zip="ngModel" [(ngModel)]="updateCareteam!.ZIP"
                     class="form-control">
              <span class="err" *ngIf="zip.touched && updateCareteam!.ZIP == ''">ZIP Code is required.</span>
              <span class="err" *ngIf="zip.touched && updateCareteam!.ZIP.length > 0 && updateCareteam!.CITY == ''">Invalid ZIP Code.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>City</label>
              <select translate="no" [(ngModel)]="updateCareteam!.CITY"
                      [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control text-capitalize mr-sm-1 mb-2"
                      (change)="showState($event)">
                <option value disabled selected>City*</option>
                <option *ngIf="updateCareteam!.CITY && getCityState.length == 0" selected disabled>{{updateCareteam!.CITY}}</option>
                <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName |titlecase}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>State</label>
              <input type="text" disabled placeholder="State" [(ngModel)]="updateCareteam!.STATE" class="form-control">
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Email</label>
              <input type="email" name="email" placeholder="Email" (keypress)="valEmail($event)" [(ngModel)]="updateCareteam!.EMAIL" class="form-control">
              <span class="err" *ngIf="emError">Enter valid email.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Specialty</label>
              <input type="text" [(ngModel)]="updateCareteam!.SPECIALITY" class="form-control">
            </div>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Relation to Patient*</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" [(ngModel)]="RELATIONTOPATIENTUPDATE" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="inlineRadio11"
                 [checked]="updateCareteam.REFERRINGPROVIDER == true ? true : ''" value="RP">
          <label class="custom-control-label" for="inlineRadio11">Referring Provider</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" [(ngModel)]="RELATIONTOPATIENTUPDATE" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="inlineRadio22"
                 [checked]="updateCareteam.PCP ? true : ''" value="PCP">
          <label class="custom-control-label" for="inlineRadio22">Primary Care Provider (PCP)</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" [(ngModel)]="RELATIONTOPATIENTUPDATE" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="other33"
                 [checked]="updateCareteam.OTHER == true ? true : ''" value="OTHER">
          <label class="custom-control-label" for="other33">Other</label>
        </div>
        <div class="mt-3">
          <div class="form-group">
            <label>Relationship<span class="text-danger">*</span></label>
            <input type="text" (keypress)="validateRelation($event)" [attr.disabled]="!updateCareteam.OTHER ? true : null" maxlength="100" [(ngModel)]="updateCareteam!.RELATION" placeholder="Enter Relationship" class="form-control">
            <span class="err" *ngIf="updateCareteam.OTHER && updateCareteam!.RELATION.length == 0">Please enter relation.</span>
          </div>
        </div>
      </div>

      <div class="modal-footer flex-column">
        <p class="text-center text-muted">Want to update info in your care team records?​</p>
        <div class="row w-100">
          <div class="col-md-12 pt-2">
            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-7">
                <button type="button" (click)="UpateCareTeam()" class="btn btn-primary btn-sm w-100 mb-2">
                  Yes,
                  I do
                </button>
              </div>
              <div class="col-md-6 col-sm-7">
                <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="reset()" data-dismiss="modal">
                  I don’t need
                  right now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Update Care Modal -->

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="UpdateCareTeamMoodal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Care Team</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="NPI" disabled [(ngModel)]="updateCareteam!.NPI" class="form-control">
              <label>NPI</label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="First Name" maxlength="35" #firstname="ngModel" [(ngModel)]="updateCareteam!.FIRST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
              <label>First Name <span class="text-danger">*</span></label>
              <span class="err" *ngIf="firstname.touched && updateCareteam!.FIRST_NAME == ''">First name is required.</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="Last Name" maxlength="35" #lastname="ngModel" [(ngModel)]="updateCareteam!.LAST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'LAST_NAME')">
              <label>Last Name <span class="text-danger">*</span></label>
              <span class="err" *ngIf="lastname.touched && updateCareteam!.LAST_NAME == ''">Last name is required.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-floating">
              <input type="text" placeholder="Address" #address="ngModel" [(ngModel)]="updateCareteam!.ADDRESS" class="form-control text-capitalize">
              <label>Address <span class="text-danger">*</span></label>
              <span class="err" *ngIf="address.touched && updateCareteam!.ADDRESS == ''">Address is required.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-floating">
              <input maxlength="10" minlength="5" (input)="onlyNumberAllow($event);" type="text"
                     placeholder="Zip Code" #zip="ngModel" [(ngModel)]="updateCareteam!.ZIP"
                     class="form-control">
              <label>ZIP Code <span class="text-danger">*</span></label>
              <span class="err" *ngIf="zip.touched && updateCareteam!.ZIP == ''">ZIP Code is required.</span>
              <span class="err" *ngIf="zip.touched && updateCareteam!.ZIP.length > 0 && updateCareteam!.CITY == ''">Invalid ZIP Code.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-select form-floating">
              <select translate="no" [(ngModel)]="updateCareteam!.CITY"
                      [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control text-capitalize mr-sm-1 mb-2"
                      (change)="showState($event)">
                <option value disabled selected>City*</option>
                <option *ngIf="updateCareteam!.CITY && getCityState.length == 0" selected disabled>{{updateCareteam!.CITY}}</option>
                <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName |titlecase}}</option>
              </select>
              <label>City <span class="text-danger">*</span></label>
              <!-- <input type="text" placeholder="City" [(ngModel)]="updateCareteam!.CITY" class="form-control"> -->
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-floating">
              <input type="text" disabled placeholder="State" [(ngModel)]="updateCareteam!.STATE" class="form-control">
              <label>State <span class="text-danger">*</span></label>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="email" name="email" placeholder="Email" (keypress)="valEmail($event)" [(ngModel)]="updateCareteam!.EMAIL" class="form-control">
              <label>Email</label>
              <span class="err" *ngIf="emError">Enter valid email.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-floating">
              <input type="text" [(ngModel)]="updateCareteam!.SPECIALITY" class="form-control">
              <label>Specialty</label>
            </div>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Relation to Patient<span class="text-danger">*</span></label>
        </div>

        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" [(ngModel)]="RELATIONTOPATIENTUPDATE" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="inlineRadio11"
                 [checked]="updateCareteam.REFERRINGPROVIDER == true ? true : ''" value="RP">
          <label class="custom-control-label" for="inlineRadio11">Referring Provider</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" [(ngModel)]="RELATIONTOPATIENTUPDATE" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="inlineRadio22"
                 [checked]="updateCareteam.PCP ? true : ''" value="PCP">
          <label class="custom-control-label" for="inlineRadio22">Primary Care Provider (PCP)</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" [(ngModel)]="RELATIONTOPATIENTUPDATE" type="radio" (change)="isRelationOtherUpdate($event)" name="inlineRadioOptions11" id="other33"
                 [checked]="updateCareteam.OTHER == true ? true : ''" value="OTHER">
          <label class="custom-control-label" for="other33">Other</label>
        </div>
        <div class="mt-3">
          <div class="form-group form-floating">
            <input type="text" (keypress)="validateRelation($event)" [attr.disabled]="!updateCareteam.OTHER ? true : null" maxlength="100" [(ngModel)]="updateCareteam!.RELATION" placeholder="Enter Relationship" class="form-control">
            <label>Relationship<span class="text-danger">*</span></label>
            <span class="err" *ngIf="updateCareteam.OTHER && updateCareteam!.RELATION.length == 0">Please enter relation.</span>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">Close</button>
        <button type="button" (click)="UpateCareTeam()" class="btn btn-primary ">Update</button>
      </div>
    </div>
  </div>
</div>


<!-- Create own New Care Modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="newCareModal">
  <form [formGroup]="addCareTeamForm" (ngSubmit)="AddCareTeam()">
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Care Team</h5>
          <button type="button" (click)="reset()" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" #scrll>
          <div class="form-row">
            <div class="col-md-6">
              <div class="form-group form-floating">
                <input formControlName="FIRST_NAME" type="text" maxlength="35" placeholder="First Name" class="form-control" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
                <label>First Name <span class="text-danger">*</span></label>
                <span class="err" *ngIf="getCareTeamForm.FIRST_NAME.invalid && getCareTeamForm.FIRST_NAME.touched">First name is required.</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group form-floating">
                <input formControlName="LAST_NAME" type="text" maxlength="35" placeholder="Last Name" class="form-control" (input)="onlyCharAllow($event.target,'LAST_NAME')">
                <label>Last Name <span class="text-danger">*</span></label>
                <span *ngIf="getCareTeamForm.LAST_NAME.invalid" class="text-left d-block text-danger">
                  <span class="err" *ngIf="getCareTeamForm.LAST_NAME.touched && getCareTeamForm.LAST_NAME.invalid">Last name is required.</span>
                </span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group form-floating">
                <input formControlName="ADDRESS" (keypress)="limitCharsOnly($event, 35)" maxlength="35" type="text" placeholder="Address" class="form-control">
                <label>Address <span class="text-danger">*</span></label>
                <span class="err" *ngIf="getCareTeamForm.ADDRESS.invalid && getCareTeamForm.ADDRESS.touched">Address is required.</span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group form-floating">
                <input formControlName="ZIP" maxlength="10" minlength="5" (input)="onlyNumberAllow($event);" type="text" placeholder="Zip Code" class="form-control">
                <label>Zip Code <span class="text-danger">*</span></label>
                <div class="err" *ngIf="getCareTeamForm.ZIP.invalid && getCareTeamForm.ZIP.touched">
                  <span class="err" *ngIf="getCareTeamForm.ZIP.errors!.required">ZIP Code is required.</span>
                  <span class="err" *ngIf="getCareTeamForm.ZIP.errors!.zipNotFound">Invalid ZIP Code.</span>
                  <span class="err" *ngIf="getCareTeamForm.ZIP.errors!.minlength">Invalid ZIP Code.</span>
                </div>
                <div class="err" *ngIf="getCareTeamForm.ZIP.valid && getCareTeamForm.CITY.touched && getCareTeamForm.CITY.invalid">
                  <span class="err" *ngIf="getCareTeamForm.CITY.errors!.required">Invalid ZIP Code.</span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group form-select form-floating">
                <select translate="no" [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control mr-sm-1 mb-2" formControlName="CITY" (change)="showState($event)">
                  <option value selected disabled>City*</option>
                  <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName}}</option>
                </select>
                <label>City <span class="text-danger">*</span></label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group form-floating">
                <input formControlName="STATE" [attr.disabled]="true" type="text" placeholder="State" class="form-control">
                <label>State <span class="text-danger">*</span></label>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group form-floating">
                <input type="email" formControlName="EMAIL" (keypress)="valEmailCreate($event)" placeholder="Email" class="form-control">
                <label>Email</label>
                <span class="err" *ngIf="getCareTeamForm.EMAIL.invalid && getCareTeamForm.EMAIL.touched">Enter valid email.</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group form-floating">
                <input formControlName="SPECIALITY" maxlength="30" type="text" placeholder="Specialty" class="form-control">
                <label>Specialty</label>
                <span class="err" *ngIf="getCareTeamForm.SPECIALITY.touched && getCareTeamForm.SPECIALITY.invalid">Speciality must not be more than 30 characters.</span>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Relation to Patient <span class="text-danger">*</span></label>
            <span class="err" *ngIf="getCareTeamForm.RELATIONTOPATIENT.invalid && getCareTeamForm.RELATIONTOPATIENT.touched"> Please select relation to patient</span>
          </div>
          <div class="custom-control custom-radio mb-1">
            <input formControlName="RELATIONTOPATIENT" class="custom-control-input" id="r" type="radio" value="RP" (change)="isRelationOther($event)">
            <label class="custom-control-label" [attr.disabled]="true" for="r">Referring Provider</label>
          </div>
          <div class="custom-control custom-radio mb-1">
            <input formControlName="RELATIONTOPATIENT" class="custom-control-input" id="p" type="radio" value="PCP" (change)="isRelationOther($event)">
            <label class="custom-control-label" for="p">Primary Care Provider (PCP)</label>
          </div>
          <div class="custom-control custom-radio mb-1">
            <input formControlName="RELATIONTOPATIENT" class="custom-control-input" id="o" type="radio" value="OTHER" (change)="isRelationOther($event)">
            <label class="custom-control-label" for="o">Other</label>
          </div>
          <div class="mt-3">
            <div class="form-group form-floating">
              <input [attr.disabled]="!isOthers ? true : null" (keypress)="validateRelation($event)" formControlName="RELATION" type="text" placeholder="Enter Relationship" class="form-control" maxlength="100">
              <label>Relationship<span class="text-danger">*</span></label>
              <span class="err" *ngIf="isOthers && getCareTeamForm.RELATION.value.length == 0 && getCareTeamForm.RELATION.touched">Please enter Relation.</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">Close</button>
          <button type="button" type="submit" class="btn btn-primary ">Add</button>
        </div>
      </div>
    </div>
  </form>
</div>

<!--new design Add care modal -->

<div class="modal fade" id="EdtCareMoodal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Care Team</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group">
              <label>NPI</label>
              <input type="text" placeholder="NPI" disabled value="{{addcareteam!.NPI}}" class="form-control">
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Last Name <span class="text-danger">*</span></label>
              <input type="text" placeholder="Last Name" required #lname="ngModel" [(ngModel)]="addcareteam.LAST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'LAST_NAME')">
              <span class="err" *ngIf="lname.touched && lname.invalid">Last name is required.</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>First Name <span class="text-danger">*</span></label>
              <input type="text" placeholder="First Name" required maxlength="35" #fname="ngModel" [(ngModel)]="addcareteam.FIRST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
              <span class="err" *ngIf="fname.touched && fname.invalid">First name is required.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Address <span class="text-danger">*</span></label>
              <input type="text" placeholder="Address" #adr="ngModel" required [(ngModel)]="addcareteam.ADDRESS" class="form-control text-capitalize" (input)="validateName($event)">
              <span class="err" *ngIf="adr.touched && adr.invalid">Address is required.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>Zip <span class="text-danger">*</span></label>
              <input maxlength="10" minlength="5" required type="text" [(ngModel)]="addcareteam.ZIP"
                     (input)="onlyNumberAllow($event)" #zi="ngModel" placeholder="ZIP Code"
                     class="form-control">
              <span class="err" *ngIf="zi.touched && addcareteam.ZIP == ''">ZIP Code is required.</span>
              <span class="err" *ngIf="zi.touched && addcareteam.ZIP.length > 0 && addcareteam.CITY == ''">Invalid ZIP Code.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>City</label>
              <select translate="no" [(ngModel)]="addcareteam!.CITY" [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control text-capitalize mr-sm-1 mb-2"
                      (change)="showState($event)">
                <option *ngIf="addcareteam.CITY != '' && getCityState.length == 0" selected disabled class="text-capitalize">{{addcareteam!.CITY}}</option>
                <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName  | titlecase}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label>State</label>
              <input type="text" disabled placeholder="specialist-content" value="{{addcareteam!.STATE}}" class="form-control">
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label>Email</label>
              <input type="email" #emm="ngModel" placeholder="Email" [(ngModel)]="addcareteam.EMAIL" (keypress)="valEmailSearchAdd($event)" class="form-control">
              <span class="err" *ngIf="emm.touched && emError1">Enter valid email.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Specialty</label>
              <input type="text" value="{{addcareteam!.SPECIALITY}}" class="form-control">
            </div>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Relation to Patient*</label>
        </div>

        <span *ngIf="relRequired" class="d-block err"> Please select Relation to Patient.</span>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                 id="b" value="RP">
          <label class="custom-control-label" for="b">Referring Provider</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                 id="n" value="PCP">
          <label class="custom-control-label" for="n">Primary Care Provider (PCP)</label>
        </div>
        <div class="custom-control custom-radio mb-1">
          <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                 id="t" value="OTHER">
          <label class="custom-control-label" for="t">Other</label>
        </div>
        <div class="mt-3">
          <div class="form-group">
            <label>Relationship<span class="text-danger">*</span></label>
            <input type="text" [attr.disabled]="!addcareteam.OTHER ? true : null" (keypress)="validateRelation($event)" maxlength="100" [(ngModel)]="addcareteam!.RELATION" placeholder="Enter Relationship" class="form-control">
            <span class="err" *ngIf="isOthersEdit && addcareteam!.RELATION.length == 0">Please enter Relation.</span>
          </div>
        </div>
      </div>
      <div class="modal-footer flex-column">
        <p class="text-center text-muted">Want to save newly added info in your care team records?​</p>
        <div class="row w-100">
          <div class="col-md-12 pt-2">
            <div class="row justify-content-center">
              <div class="col-md-6 col-sm-7">
                <button type="button" (click)="SaveCareTeam()" class="btn btn-primary btn-sm w-100 mb-2">
                  Yes,
                  I do
                </button>
              </div>
              <div class="col-md-6 col-sm-7">
                <button type="button" class="btn btn-outline-primary btn-sm w-100"
                        data-dismiss="modal" (click)="reset()">
                  I don’t need
                  right now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Care Team from search Modal -->
<!--<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="EdtCareMoodal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Care Team</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="reset()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" #scrllSearch>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="NPI" disabled value="{{addcareteam!.NPI}}" class="form-control">
              <label>NPI</label>
            </div>
          </div>
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="First Name" required maxlength="35" #fname="ngModel" [(ngModel)]="addcareteam.FIRST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'FIRST_NAME')">
              <label>First Name <span class="text-danger">*</span></label>
              <span class="err" *ngIf="fname.touched && fname.invalid">First name is required.</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="Last Name" required #lname="ngModel" [(ngModel)]="addcareteam.LAST_NAME" class="form-control text-capitalize" (input)="onlyCharAllow($event.target,'LAST_NAME')">
              <label>Last Name <span class="text-danger">*</span></label>
              <span class="err" *ngIf="lname.touched && lname.invalid">Last name is required.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-floating">
              <input type="text" placeholder="Address" #adr="ngModel" required [(ngModel)]="addcareteam.ADDRESS" class="form-control text-capitalize" (input)="validateName($event)">
              <label>Address <span class="text-danger">*</span></label>
              <span class="err" *ngIf="adr.touched && adr.invalid">Address is required.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-floating">
              <input maxlength="10" minlength="5" required type="text" [(ngModel)]="addcareteam.ZIP"
                     (input)="onlyNumberAllow($event)" #zi="ngModel" placeholder="ZIP Code"
                     class="form-control">
              <label>Zip Code<span class="text-danger">*</span></label>
              <span class="err" *ngIf="zi.touched && addcareteam.ZIP == ''">ZIP Code is required.</span>
              <span class="err" *ngIf="zi.touched && addcareteam.ZIP.length > 0 && addcareteam.CITY == ''">Invalid ZIP Code.</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-floating form-select">-->
<!-- <input type="text" disabled placeholder="City" value="{{addcareteam!.CITY | titlecase}}" class="form-control">
<label>City <span class="text-danger">*</span></label> -->
<!-- [attr.readonly]="getCityState.length == 0 ? true : null" -->
<!--<select translate="no" [(ngModel)]="addcareteam!.CITY" [attr.readonly]="getCityState.length == 0 ? true : null" class="form-control text-capitalize mr-sm-1 mb-2"
        (change)="showState($event)">-->
<!-- <option value disabled selected>City*</option> -->
<!--<option *ngIf="addcareteam.CITY != '' && getCityState.length == 0" selected disabled class="text-capitalize">{{addcareteam!.CITY}}</option>
                <option *ngFor="let city of getCityState; let i = index;" [selected]="i == 0" value="{{city.cityName}}">{{city.cityName  | titlecase}}</option>
              </select>
              <label>City <span class="text-danger">*</span></label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-floating">
              <input type="text" disabled placeholder="specialist-content" value="{{addcareteam!.STATE}}" class="form-control">
              <label>State <span class="text-danger">*</span></label>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-floating">
              <input type="email" #emm="ngModel" placeholder="Email" [(ngModel)]="addcareteam.EMAIL" (keypress)="valEmailSearchAdd($event)" class="form-control">
              <label>Email</label>
              <span class="err" *ngIf="emm.touched && emError1">Enter valid email.</span>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-floating">
              <input type="text" value="{{addcareteam!.SPECIALITY}}" class="form-control">
              <label>Specialty</label>
            </div>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Relation to Patient <span class="text-danger">*</span></label>
          <span *ngIf="relRequired" class="d-block err"> Please select Relation to Patient.</span>
          <div class="custom-control custom-radio mb-1">
            <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                   id="b" value="RP">
            <label class="custom-control-label" for="b">Referring Provider</label>
          </div>
          <div class="custom-control custom-radio mb-1">
            <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                   id="n" value="PCP">
            <label class="custom-control-label" for="n">Primary Care Provider (PCP)</label>
          </div>
          <div class="custom-control custom-radio mb-1">
            <input class="custom-control-input" (change)="isRelationOtherEdit($event)" type="radio" name="editRadio"
                   id="t" value="OTHER">
            <label class="custom-control-label" for="t">Other</label>
          </div>
          <div class="mt-3">
            <div class="form-group form-floating">
              <input type="text" [attr.disabled]="!addcareteam.OTHER ? true : null" (keypress)="validateRelation($event)" maxlength="100" [(ngModel)]="addcareteam!.RELATION" placeholder="Enter Relationship" class="form-control">
              <label>Relationship<span class="text-danger">*</span></label>
              <span class="err" *ngIf="isOthersEdit && addcareteam!.RELATION.length == 0">Please enter Relation.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="reset()" data-dismiss="modal">Close</button>
        <button type="button" (click)="SaveCareTeam()" class="btn btn-primary ">Add</button>
      </div>
    </div>
  </div>
</div>-->
<!-- delete care team modal -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="deleteCareTeamModal">
  <!--   <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Breeze Check-in</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="mb-0">Are you sure you want to delete?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary " data-dismiss="modal" id="closeDeleteAllergyModel">Cancel</button>
        <button type="button" id="closeDeleteFamilyHistory" (click)="DeleteCareTeam()" class="btn btn-primary ">Delete</button>
      </div>
    </div>
  </div> -->

  <div class="modal-dialog  modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{'careteam.careTeam'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-4">
        <p>{{'careteam.are_you_sure_you_want_to_delete_your'|translate}} <strong>{{relation}} {{cTeamDeleted.FIRSTNAME |titlecase}} {{cTeamDeleted.LASTNAME | titlecase}}</strong>?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" data-dismiss="modal" id="closeDeleteAllergyModel">{{'button.cancel'|translate}}</button>
        <button type="button" class="btn btn-primary px-3" (click)="DeleteCareTeam()">{{'button.delete'|translate}}</button>
      </div>
    </div>
  </div>


  <!--<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>Are you sure you want to delete?</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal" id="closeDeleteAllergyModel">Cancel</button>
        <button type="button" id="closeDeleteFamilyHistory" (click)="DeleteCareTeam()" class="btn btn-primary ">Delete</button>
      </div>
    </div>
  </div>-->

</div>

<div class="modal fade" id="confirmAddcareTeam" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{'careteam.careTeam'|translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-4">
        <p>
          {{'careteam.are_you_sure_you_want_to_add'|translate}} <strong>{{this.addcareteam.FIRST_NAME | titlecase}} {{addcareteam.LAST_NAME |titlecase }} </strong> {{'careteam.as_a'|translate}} <strong>{{relation}}</strong>  {{'careteam.into_your_care_team'|translate}}?
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" data-dismiss="modal">{{'button.no'|translate}}</button>
        <button type="button" class="btn btn-primary px-3" data-toggle="modal" data-dismiss="modal" (click)="SaveCareTeam()">{{'button.yes'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<!--<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="deleteCareTeamModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <p class="font-weight-bolder mb-3 text-danger">{{'careteam.are_you_sure_you_want_to_delete_your'|translate}} <strong>{{cTeamDeleted.RELATION}} {{cTeamDeleted.FIRSTNAME |titlecase}} {{cTeamDeleted.LASTNAME | titlecase}}</strong>?</p>
      
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal" id="closeDeleteAllergyModel">{{'button.cancel'|translate}}</button>
        <button type="button" id="closeDeleteFamilyHistory" (click)="DeleteCareTeam()" class="btn btn-primary ">{{'button.delete'|translate}}</button>
      </div>
    </div>
  </div>

</div>-->
